
import { defineComponent, PropType } from 'vue'
import { ElementDatasetSet } from '@/types/dataset'
import { mapState } from 'pinia'
import { useElementsStore } from '@/stores'
import { Element } from '@/types'
import Row from './Row.vue'

export default defineComponent({
  components: {
    Row
  },
  props: {
    corpusId: {
      type: String,
      required: true
    },
    element: {
      type: Object as PropType<Element>,
      required: true
    }
  },
  computed: {
    ...mapState(useElementsStore, ['elementDatasetSets']),
    datasetSets (): ElementDatasetSet[] | null {
      return this.elementDatasetSets?.[this.element.id] ?? null
    }
  }
})
